import { Component, HostListener, input, output, ChangeDetectionStrategy } from '@angular/core';
import { ReBaseData } from '../../utils/re-base-data';
@Component({
    selector: 'bdo-confirmation-popup',
    templateUrl:  './confirmation-popup.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmationPopupComponent {

  public title = input<string>('');
  public cancelText = input<string>('');
  public confirmText = input<string>('');
  public isVisible = input<boolean>(false);

  /**
   * sometimes the meaning of confirm and cancel is inverted ("Abbrechen ohne zu Speichern" means -> confirm cancel)
   */
  readonly confirmationResult = output<boolean>();
  protected reBaseData = ReBaseData;

  constructor() { }

  @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      this.cancel();
    }
  }

  confirm() {
    this.confirmationResult.emit(true);
  }

  cancel() {
    this.confirmationResult.emit(false);
  }

}
